
/**
 * Helper function to sort floorplans
 *
 * @param {Array} floorPlans - the array of floorPlans to sort
 * @return {Array} The sorted array
 */
export const sortFloorPlans = floorPlans => {
  const collator = new Intl.Collator(navigator.languages ? navigator.languages[0] : navigator.language, { numeric: true, ignorePunctuation: true })

  return floorPlans.sort((a, b) => {
    const firstStr = (a.name || `Floor Plan ${a.id}`).toLowerCase()
    const secondStr = (b.name || `Floor Plan ${b.id}`).toLowerCase()

    return collator.compare(firstStr, secondStr)
  })
}

/**
 * Helper function to sort items by key prop
 *
 * @param {Array} items - the array of items with name props to sort
 * @param {String} key - the prop key to sort by, defaults to `'name'`
 * @return {Array} The sorted array
 */
export default (items, key = 'name') => {
  const collator = new Intl.Collator(navigator.languages ? navigator.languages[0] : navigator.language, { numeric: true, ignorePunctuation: true })

  return items.sort((a, b) => collator.compare(a[key].toLowerCase(), b[key].toLowerCase()))
}



// WEBPACK FOOTER //
// ./src/helpers/sortItems.js